import { Component, OnInit } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from './core/services/translation-loader.service';

import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseNavigationModel } from './navigation/navigation.model';
import { locale as navigationEnglish } from './main/i18n/en';
import { locale as navigationSpanish } from './main/i18n/es';
import { AuthenticationService } from './main/services/authentication/authentication.service';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        private fuseNavigationService: FuseNavigationService,
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService,
        private authenticationService: AuthenticationService,
        private router: Router,
        private ngxPermissionsService: NgxPermissionsService
    ) {
        // Add languages
        this.translate.addLangs(['en', 'es']);

        // Set the default language
        this.translate.setDefaultLang('es');

        // Set the navigation model
        this.fuseNavigationService.setNavigationModel(new FuseNavigationModel());

        // Set the navigation translations
        this.translationLoader.loadTranslations(navigationEnglish, navigationSpanish);
    }

    ngOnInit() {
        let authData = this.authenticationService.getAuthData();
        if (!authData) {
            this.router.navigate(['pages/auth/login-2']);
            return;
        }

        this.authenticationService.user.UserName = authData.UserName;
        this.authenticationService.user.Email = authData.Email;
        this.authenticationService.user.FirstName = authData.FirstName;
        this.authenticationService.user.LastName = authData.LastName;
        this.authenticationService.user.Photo = authData.Photo;
        this.authenticationService.user.UpdatedDate = !!authData.UpdatedDate ? new Date(authData.UpdatedDate) : null;

        let permissions = this.authenticationService.getPermissions();
        // console.log('AppComponent > ngOnInit > permissions', permissions);
        this.ngxPermissionsService.loadPermissions(permissions);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts